import { Heading } from "@/components/catalyst-ui/heading";
import { Text } from "@/components/catalyst-ui/text";
import { Button } from "@/components/catalyst-ui/button";
import { EmptyStateIcon } from "@/assets/icons";
import posthogAnalytics from "@/lib/posthog";

export default function CriticalErrorPage({ error = null }) {
  const handleContactSupport = () => {
    // Track support contact action
    posthogAnalytics.track("error_user_action", {
      action_type: "contact_support",
      error_severity: "criticalErrorPage",
      error_message:
        typeof error === "string" ? error : error?.message || "Unknown error",
      page: window.location.pathname,
    });
    window.open("https://codedesign.ai/support", "_blank");
  };

  const handleReload = () => {
    // Track reload action
    posthogAnalytics.track("error_user_action", {
      action_type: "reload",
      error_severity: "criticalErrorPage",
      error_message:
        typeof error === "string" ? error : error?.message || "Unknown error",
      page: window.location.pathname,
    });
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-6 flex items-center justify-center">
          <EmptyStateIcon className="w-32 h-32 text-[#D4D4D8]" />
        </div>

        <Heading
          level={1}
          className="!text-2xl !font-bold !text-[#09090B] mb-3"
        >
          Houston, we have a problem! 🚀
        </Heading>

        <Text className="!text-base !text-[#71717A] mb-2">
          Something went wrong while connecting to our servers.
        </Text>

        <Text className="!text-sm !text-[#A1A1AA] mb-8">
          Don&apos;t worry, our team is probably already on it. If this keeps
          happening, please reach out to our support team.
        </Text>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            outline
            onClick={handleReload}
            className="px-6 py-2 !text-base data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
          >
            Try Again
          </Button>
          <Button
            color="dark"
            onClick={handleContactSupport}
            className="px-6 py-2 !text-base data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
          >
            Contact Support
          </Button>
        </div>

        {error && import.meta.env.DEV && (
          <div className="mt-8 p-4 bg-red-50 border border-red-200 rounded-lg text-left">
            <Text className="!text-xs !font-mono !text-red-600 break-all">
              {typeof error === "string"
                ? error
                : error?.message || "Unknown error"}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
}
